export default class FieldReader{

  constructor () {
    this.excludedFieldTypes = []
  }


  addExcludedFieldType(fieldType){
    this.excludedFieldTypes.push(fieldType)
  }

  setExcludedFieldTypes(fieldTypes){
    this.excludedFieldTypes = fieldTypes
  }


  getFlattenedFields(fields) {
      let results = []
      fields.forEach(field =>{

        if(this.excludedFieldTypes.includes(field.type)){
          return
        }

        if(field.type == "table"){
          results = [...results, ...this.__getTabelFields(field) ];
          return
        }

        results.push(field)
      })
      return results
    }

  __getTabelFields(tableField){
    let results = []
    tableField['sub-fields'].forEach(subField =>{
      if(this.excludedFieldTypes.includes(subField.type)){
        return
      }
      let newSubField = {name : tableField.name + " - " + subField.name, id: subField.id }
      results.push(newSubField)
    })
    return results
  }
}
